import React, {useState} from 'react';
import Form, { Actions, Address, Checkboxes, PhoneNumberValidator, EmailAddressValidator, Frequency, RequiredValidator, Select, Services, TextArea, TextField, ULID, PhoneNumber, CustomValidator } from '../../Components/Form';
import {BuildingTypes, Bedrooms, Availabilities} from '../../Data/PropertyOptions';

const QuoteForm = ({quote, onSubmit, afterSubmit}) => {
    // Used for conditional validation
    const [email, setEmail] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);

    return <Form data={quote} onSubmit={onSubmit} afterSubmit={afterSubmit} closeModalOnSubmit>
        <ULID name="quoteId" />
        <TextField name="name" label="Name" validators={[RequiredValidator]} />
        <TextField name="email"
            type="email"
            label="Email"
            validators={[
                EmailAddressValidator,
                CustomValidator((value) => !!value || !!phoneNumber, 'An email address or phone number is required')
            ]}
            onChange={setEmail}
        />
        <PhoneNumber name="phoneNumber"
            label="Phone Number"
            validators={[
                PhoneNumberValidator,
                CustomValidator((value) => !!value || !!email, 'An email address or phone number is required')
            ]}
            onChange={setPhoneNumber}
        />
        <Address name="address" label="Address" validators={[RequiredValidator]} />
        <Select name="buildingType"
            label="Building Type"
            unselected="Select building type"
            options={BuildingTypes.map(b => ({value: b.name, label: b.name}))}
        />
        <Select name="bedrooms"
            label="Bedrooms"
            unselected="Select number of bedrooms"
            options={Bedrooms.map(b => ({value: b, label: b}))}
        />
        <Services name="services" label="Services" validators={[RequiredValidator]} />
        <Frequency name="frequency" label="Frequency" />
        <Checkboxes name="availability" label="Availability" options={Availabilities.map(a => ({value: a, label: a}))} />
        <TextArea name="notes" label="Notes" />
        <Actions submit={{label: 'Add'}} cancel />
    </Form>
}

export default QuoteForm;

/*
{
    type: 'Checkboxes',
    name: 'availability',
    label: 'Availability',
    required: false,
    options: Availabilities,
    value: []
},
*/
